import React from 'react';
import { useTranslation } from 'react-i18next';
import Avigilon from '../../images/video/avigilon.jpg';
import BackButton from '../../components/BackButton';

export default function MotorolaPage() {
  const { t } = useTranslation('videosolutions');

  return (
    <section className="relative min-h-screen text-white bg-gradient-to-b from-[#070b15] to-[#0a111f] pt-32 pb-24 overflow-hidden">
      <div className="grid-bg opacity-60" />
      <div className="glow-orb w-[520px] h-[520px] bg-[#0070d2] opacity-20 -top-40 -left-32 [animation:drift-slow_24s_ease-in-out_infinite,glow-pulse_9s_ease-in-out_infinite]" />
      <div className="glow-orb w-[440px] h-[440px] bg-[#00c2ff] opacity-20 bottom-[-160px] right-[-140px] [animation:drift_15s_ease-in-out_infinite_2s,glow-pulse_9s_ease-in-out_infinite_1.5s]" />

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 animate-fade-in">
        <BackButton label={t('back')} to="/video" />

        <h1 className="font-display text-4xl sm:text-5xl font-bold text-white">
          Motorola Solutions
        </h1>
        <span className="title-accent is-visible mb-10" />

        <div className="glass-card rounded-3xl overflow-hidden md:flex md:items-stretch">
          <div className="relative md:w-1/2 h-64 md:h-auto min-h-[280px]">
            <img
              src={Avigilon}
              alt="Motorola Solutions"
              className="absolute inset-0 w-full h-full object-cover opacity-80"
            />
            <div
              className="absolute inset-0"
              style={{
                background:
                  'radial-gradient(circle at 30% 25%, rgba(0,194,255,0.25), transparent 60%), linear-gradient(180deg, rgba(5,8,16,0.05), rgba(5,8,16,0.5))',
              }}
            />
          </div>
          <div className="md:w-1/2 p-8 sm:p-10 flex items-center">
            <p className="text-white/70 text-lg leading-relaxed">{t('solutions.motorola')}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
